import path from "path";

import { copy, pathExists, readFile } from "fs-extra";

import { ILogger } from "../../Commons/Logging/ILogger";
import { getLogger } from "../../Commons/Logging/StaticLogger";
import { BuildCache, FormBuildCacheOptions } from "../../FormWebpackConfiguration/CacheAssetsPlugin";

export async function writeAttachmentPathFiles(
    gfv: string,
    formPath: string,
    resourcesDirectory: string,
    parentLogger: ILogger = getLogger(),
    buildCache?: BuildCache,
    buildCacheOptions?: FormBuildCacheOptions
): Promise<void> {
    const logger = parentLogger.withPrefix(`ATTACHPATH:${gfv}`);
    const sourceFile = path.join(formPath, "form", "AttachmentPaths.json");
    const targetFile = path.join(resourcesDirectory, "attachmentpaths", `${gfv}.json`);
    if (await pathExists(sourceFile)) {
        logger.log(`copy\n  from: ${sourceFile}\n  to:   ${targetFile}`);
        await copy(sourceFile, targetFile);

        if (buildCache != undefined && buildCacheOptions != undefined) {
            await buildCache.setContent(
                buildCacheOptions.generatorVersion,
                buildCacheOptions.gfv,
                buildCacheOptions.depsHash,
                path.join("attachmentpaths", `${gfv}.json`),
                await readFile(sourceFile, "utf-8")
            );
        }
    } else {
        logger.log(`No attachment paths\n  at: ${sourceFile}`);
    }
}
